export const ProgressSpinnerSizes = {
  Small: 0,
  Medium: 1,
  Large: 2,
} as const;
export type ProgressSpinnerSizes =
  (typeof ProgressSpinnerSizes)[keyof typeof ProgressSpinnerSizes];
